'use client'
import { ButtonRoundStyle, Icon } from '@/components'
import { CALLBACK_URL_KEY } from '@/constants'
import Link from '@/features/ref/components/Link'
import { Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { TitleLoginForm } from '../../components'
import { IdentifierForm, RegisterForm, RegisterOtpForm } from './components'

type Props = {
  socialLoginUrls?: any[]
  goToLoginPage?: () => void
  hideLoginLink?: boolean
}

export const RegisterPage = ({ socialLoginUrls, goToLoginPage, hideLoginLink = false }: Props) => {
  const t = useTranslations('UserProfile')
  const searchParams = useSearchParams()
  const [step, setStep] = useState<'IDENTIFIER' | 'OTP' | 'REGISTER'>('IDENTIFIER')
  const [identifier, setIdentifier] = useState<string>('')
  const [identifierType, setIdentifierType] = useState<'email' | 'phone'>('email')

  // Handlers để chuyển step với data
  const goToOtpStep = (userIdentifier: string, type: 'email' | 'phone') => {
    setIdentifier(userIdentifier)
    setIdentifierType(type)
    setStep('OTP')
  }

  const goToRegisterStep = (otpCode: string) => {
    setStep('REGISTER')
  }

  const goBackToIdentifier = () => {
    setStep('IDENTIFIER')
    setIdentifier('')
    setIdentifierType('email')
  }

  return (
    <Stack spacing={2}>
      <TitleLoginForm align="center" title={t('Hãy tạo tài khoản tích xu ngay từ hôm nay')} />
      {step === 'IDENTIFIER' && (
        <>
          {socialLoginUrls && socialLoginUrls.length > 0 && (
            <ButtonRoundStyle
              LinkComponent={'a'}
              href={socialLoginUrls?.find((item) => item.key === 'google')?.login_url || '#'}
              onClick={() => {
                localStorage.setItem(CALLBACK_URL_KEY, searchParams.get(CALLBACK_URL_KEY) || '/')
              }}
              variant="outlined"
              sx={{
                gap: 1,
                '&.Mui-disabled': {
                  opacity: 0.6,
                },
              }}
            >
              <Icon.Google /> {t('Đăng nhập bằng Google')}
            </ButtonRoundStyle>
          )}
        </>
      )}
      {step === 'IDENTIFIER' && <IdentifierForm onNext={goToOtpStep} />}

      {step === 'OTP' && (
        <RegisterOtpForm
          identifier={identifier}
          identifierType={identifierType}
          onNext={goToRegisterStep}
          onBack={goBackToIdentifier}
        />
      )}

      {step === 'REGISTER' && (
        <RegisterForm verifiedIdentifier={identifier} identifierType={identifierType} />
      )}

      {/* Chỉ hiển thị link đăng nhập ở step đầu và cuối */}

      {step === 'IDENTIFIER' && !hideLoginLink && (
        <Typography variant="body2">
          {t('Nếu bạn đã có tài khoản')}{' '}
          <Typography
            component="span"
            sx={{
              fontWeight: 600,
              fontSize: '1em',
              '& a': {
                color: 'inherit',
                textDecoration: 'none',
                transition: 'all 0.3s',
                '&:hover': {
                  textDecoration: 'underline',
                  opacity: 0.8,
                },
              },
            }}
          >
            <Link
              href={
                '/login?' +
                CALLBACK_URL_KEY +
                '=' +
                encodeURIComponent(searchParams.get(CALLBACK_URL_KEY) || '')
              }
              onNavigate={(e) => {
                if (goToLoginPage) {
                  e.preventDefault()
                  goToLoginPage()
                }
              }}
            >
              {t('Đăng nhập ngay')}
            </Link>
          </Typography>
        </Typography>
      )}
    </Stack>
  )
}
